import * as React from 'react';

import { SubtleSwitch } from '@/imports/ui/chakra/components/SubtleSwitch';

export type RemoveAllOtherGroupMembersToggleProps = {
  shouldRemoveAllOtherGroupMembers: boolean;
  setShouldRemoveAllOtherGroupMembers: (value: boolean) => void;
  label: string;
};

export const RemoveAllOtherGroupMembersToggle: React.FC<
  RemoveAllOtherGroupMembersToggleProps
> = ({
  shouldRemoveAllOtherGroupMembers,
  setShouldRemoveAllOtherGroupMembers,
  label,
}) => {
  return (
    <SubtleSwitch
      isChecked={shouldRemoveAllOtherGroupMembers}
      onChange={(event) =>
        setShouldRemoveAllOtherGroupMembers(event.target.checked)
      }
    >
      {label}
    </SubtleSwitch>
  );
};
